var map = {
	"./blogger.svg": 51,
	"./collections.svg": 52,
	"./delicious.svg": 53,
	"./digg.svg": 54,
	"./evernote.svg": 55,
	"./facebook.svg": 56,
	"./linkedin.svg": 57,
	"./lj.svg": 58,
	"./messenger.svg": 59,
	"./moimir.svg": 60,
	"./odnoklassniki.svg": 61,
	"./pinterest.svg": 62,
	"./pocket.svg": 63,
	"./qzone.svg": 64,
	"./reddit.svg": 65,
	"./renren.svg": 66,
	"./sinaWeibo.svg": 67,
	"./skype.svg": 68,
	"./surfingbird.svg": 69,
	"./telegram.svg": 70,
	"./tencentWeibo.svg": 71,
	"./tumblr.svg": 72,
	"./twitter.svg": 73,
	"./viber.svg": 74,
	"./vkontakte.svg": 75,
	"./whatsapp.svg": 76
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50;